import styled from 'styled-components/macro';
import * as colors from 'components/common/colorConstants';
import { lowHeightScreens, mediumScreens } from 'components/common/fontElements';

export const Section = styled.div`
  padding: 23px 55px;
  border-bottom: 1px solid ${colors.lightGray15};
  font-family: Roboto, sans-serif;
  background-color: ${(props) => (props.active ? colors.lightGray17 : colors.baseBackground)};
  transition: 0.3s;
  color: ${colors.lightBlack};
  word-break: break-word;

  h2 {
    font-size: 14px;
    font-weight: 500;
    margin: 0px;
  }

  p {
    margin: 25px 0px 0px 0px;
    line-height: 19px;
    font-size: 12px;
    animation-direction: forwards;
    animation-name: fadeIn;
    animation-duration: 1s;
    white-space: pre-wrap;

    @keyframes fadeIn {
      0% {
        opacity: 0%;
      }
      100% {
        opacity: 100%;
      }
    }
  }

  @media screen and (max-width: ${mediumScreens}), screen and (max-height: ${lowHeightScreens}) {
    p {
      font-size: 10px;
    }
    h2 {
      font-size: 12px;
    }
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  div {
    color: ${colors.darkGray1};
    font-size: 13px;
    position: relative;
    left: 25px;
    cursor: pointer;
  }

  img {
    height: 5px;
    margin-left: 5px;
  }
`;

export const Header = styled.div`
  padding: 26px 55px;
  border-bottom: 1px solid ${colors.lightGray15};

  h1 {
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 22px;
    letter-spacing: 0.0206182px;
    color: ${colors.lightBlack};
  }

  img {
    position: absolute;
    top: 20px;
    right: 15px;
    cursor: pointer;
  }
`;

export const HomepageHeader = styled.div`
  margin-top: 10px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: ${colors.lightBlack};
`;

export const Timestamp = styled.div`
  line-height: 16px;
  font-size: 10px;
  font-weight: normal;
  font-family: 'Roboto', sans-serif;
  color: ${colors.darkGray1};
  > span:not(:first-child) {
    margin-left: 5px;
    font-weight: 500;
  }
`;
